import React, { useState } from "react";
import NormalInput from "component/common/NormalInput/index";
import ErrorMessage from "component/common/ErrroMessage/index";
import { useForm } from "react-hook-form";
import { Toast } from "utils/toast";
import { useHistory } from "react-router-dom";
import { resetPassword } from "service/Auth";
import ResetPopUp from "./ResetPopUp";

import styles from "./ResetPassword.module.scss";

const ResetPassword = () => {
  const history = useHistory();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  let [isOpen, setIsOpen] = useState(false);

  const onSubmit = async (data) => {
    try {
      let response = await resetPassword(data);
      if (response.status == 200) {
        setIsOpen(true);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
    history.push("/");
  };

  return (
    <>
      <div className={styles.reset}>
        <div className={styles.reset_title}>
          <b>RECOVER PASSWORD</b>
          <span>
            Enter your email address for your account below and we will send you
            a password reset link
          </span>
        </div>
        <div className={styles.reset_field}>
          <NormalInput
            register={register("emailId", {
              required: true,
              pattern:
                /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
            })}
            error={errors.emailId}
            label="Email ID"
            width="100%"
          />
          <ErrorMessage
            error={errors.emailId}
            message={{
              required: "Please enter email id",
              pattern: "Please enter valid email id",
            }}
          />
        </div>
        <div className={styles.back_login}>
          <span onClick={() => history.push("/")}>Back to Sign In</span>
        </div>
        <div className={styles.btn_link}>
          <button onClick={handleSubmit(onSubmit)}>REQUEST LINK</button>
        </div>
      </div>
      <ResetPopUp isOpen={isOpen} toggle={toggle} />
    </>
  );
};

export default ResetPassword;
